import { describe, expect, it } from '@jest/globals';
import { getMostSpecificMatchingRange } from './getMostSpecificMatchingRange.js';

describe('getMostSpecificMatchingRange', () => {
  it('returns the most specific matching range when multiple ranges satisfy the version', () => {
    const version = '1.2.3';
    const ranges = ['^1.0.0', '^1.1.0', '~1.2.0'];
    const result = getMostSpecificMatchingRange(version, ranges);
    expect(result).toBe('~1.2.0');
  });

  it('returns undefined when no ranges match the version', () => {
    const version = '2.0.0';
    const ranges = ['^1.0.0', '~1.2.0'];
    const result = getMostSpecificMatchingRange(version, ranges);
    expect(result).toBeUndefined();
  });

  it('handles invalid semver ranges gracefully', () => {
    const version = '1.2.3';
    const ranges = ['invalid-range', '^1.0.0'];
    const result = getMostSpecificMatchingRange(version, ranges);
    expect(result).toBe('^1.0.0');
  });

  it('returns the single match when only one range matches', () => {
    const version = '1.2.3';
    const ranges = ['^0.5.0', '^1.0.0'];
    const result = getMostSpecificMatchingRange(version, ranges);
    expect(result).toBe('^1.0.0');
  });

  it('returns undefined when the input range list is empty', () => {
    const version = '1.2.3';
    const ranges: string[] = [];
    const result = getMostSpecificMatchingRange(version, ranges);
    expect(result).toBeUndefined();
  });

  it('treats "*" as the lowest specificity match when other specific ranges also match', () => {
    const version = '1.2.3';
    const ranges = ['^1.1.0', '*'];
    const result = getMostSpecificMatchingRange(version, ranges);
    expect(result).toBe('^1.1.0'); // because ^1.1.0 is more specific than *
  });

  it('returns "*" when it is the only matching range', () => {
    const version = '5.6.7';
    const ranges = ['^1.0.0', '*'];
    const result = getMostSpecificMatchingRange(version, ranges);
    expect(result).toBe('*');
  });
});
